/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipForwardIcon32Regular = forwardRef('MediaUiASkipForwardIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26 6a1 1 0 1 0-2 0v9.856a2.478 2.478 0 0 0-1.13-1.95L9.866 5.426C8.203 4.34 6 5.533 6 7.518v16.962c0 1.985 2.203 3.178 3.866 2.094l13.004-8.48a2.478 2.478 0 0 0 1.13-1.95V26a1 1 0 1 0 2 0V6ZM8 7.52a.5.5 0 0 1 .773-.42l13.004 8.481a.5.5 0 0 1 0 .838l-13.004 8.48A.5.5 0 0 1 8 24.482V7.519Z" })));
});
